var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "560px",
        "append-to-body": "",
        "before-close": _vm.handleDialogClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "assignForm",
          attrs: {
            model: _vm.assignForm,
            rules: _vm.assignRules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "咨询事项", prop: "category_id" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择", clearable: "" },
                  on: { change: _vm.handleCategoryChange },
                  model: {
                    value: _vm.assignForm.category_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.assignForm, "category_id", $$v)
                    },
                    expression: "assignForm.category_id",
                  },
                },
                [
                  _vm._l(_vm.ticketCategoryTree, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: String(item.id) },
                    })
                  }),
                  _c("el-option", { attrs: { label: "其他", value: "0" } }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "二级事项", prop: "second_category_id" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择", clearable: "" },
                  on: { change: _vm.handleSecondCategoryChange },
                  model: {
                    value: _vm.assignForm.second_category_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.assignForm, "second_category_id", $$v)
                    },
                    expression: "assignForm.second_category_id",
                  },
                },
                [
                  _vm._l(_vm.secondCategoryOptions, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: String(item.id) },
                    })
                  }),
                  _c("el-option", { attrs: { label: "其他", value: "0" } }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "具体事项", prop: "item_id" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择", clearable: "" },
                  on: { change: _vm.handleItemChange },
                  model: {
                    value: _vm.assignForm.item_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.assignForm, "item_id", $$v)
                    },
                    expression: "assignForm.item_id",
                  },
                },
                [
                  _vm._l(_vm.itemOptions, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: String(item.id) },
                    })
                  }),
                  _c("el-option", { attrs: { label: "其他", value: "0" } }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "工单负责人", prop: "handler_id" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请选择",
                    multiple: "",
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.searchHandler,
                    loading: _vm.personLoading,
                    "no-data-text": "无数据",
                  },
                  on: {
                    clear: function ($event) {
                      return _vm.searchHandler("")
                    },
                  },
                  model: {
                    value: _vm.assignForm.handler_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.assignForm, "handler_id", $$v)
                    },
                    expression: "assignForm.handler_id",
                  },
                },
                _vm._l(_vm.personOptions.handler || [], function (user) {
                  return _c("el-option", {
                    key: user.id,
                    attrs: {
                      label: user.name || user.nick_name || String(user.id),
                      value: String(user.id),
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入...",
                  maxlength: "300",
                  "show-word-limit": "",
                  rows: 4,
                },
                model: {
                  value: _vm.assignForm.remarks,
                  callback: function ($$v) {
                    _vm.$set(_vm.assignForm, "remarks", $$v)
                  },
                  expression: "assignForm.remarks",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.assignLoading },
              on: { click: _vm.submitAssign },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }